export default __webpack_public_path__ + "images/OX.b474d21.png";